<template>
  <div>
    <div class="app-card-header primary-actions">
      <div class="heading-block">
        <h4 class="heading">Fast-Moving</h4>
      </div>
      <div class="actions-block">
        <!--Category Select-->
        <div class="dropdown-filter">
          <v-autocomplete
            @change="updateByFilters($event, 'category')"
            :value="getSelectedFilters.category"
            :items="getCategories"
            :loading="category.isLoading"
            :search-input.sync="category.search"
            :disabled="getChartStatus.loading"
            noFilter
            :ripple="false"
            background-color="rgba(48, 127, 255, 0.1)"
            clearable
            hide-details
            clear-icon
            append-icon="expand_more"
            item-text="name"
            item-value="id"
            label="Category"
            no-data-text="Type to search"
            solo
            flat
          >
            <template v-slot:item="{ item }">
              <v-list-tile-content>
                <v-list-tile-title :class="`option-level-${item.level}`" v-text="item.name"></v-list-tile-title>
              </v-list-tile-content>
            </template>
          </v-autocomplete>
        </div>
        <!--Brands Select-->
        <div class="dropdown-filter">
          <v-autocomplete
            @change="updateByFilters($event, 'brand')"
            :value="getSelectedFilters.brand"
            :items="getBrands"
            :loading="brand.isLoading"
            :search-input.sync="brand.search"
            :disabled="getChartStatus.loading"
            noFilter
            :ripple="false"
            background-color="rgba(48, 127, 255, 0.1)"
            clearable
            hide-details
            clear-icon
            append-icon="expand_more"
            item-text="name"
            item-value="id"
            label="Brand"
            no-data-text="Type to search"
            solo
            flat
          >
          </v-autocomplete>
        </div>
        <!--Seller Select-->
        <div class="dropdown-filter">
          <v-autocomplete
            @change="updateByFilters($event, 'seller')"
            :value="getSelectedFilters.seller"
            :items="getSellers"
            :loading="sellers.isLoading"
            :search-input.sync="sellers.search"
            :disabled="getChartStatus.loading"
            noFilter
            :ripple="false"
            background-color="rgba(48, 127, 255, 0.1)"
            clearable
            hide-details
            clear-icon
            append-icon="expand_more"
            item-text="name"
            item-value="id"
            label="Seller"
            no-data-text="Type to search"
            solo
            flat
          >
          </v-autocomplete>
        </div>
        <!--Date Pick-->
        <div class="dropdown-filter min">
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn
                color="primary"
                flat
                small
                :ripple="false"
                :disabled="getChartStatus.loading"
                v-on="on"
              >
                <v-icon class="mr-1">event</v-icon>{{dateText(getSelectedFilters.date)}}
              </v-btn>
            </template>
            <v-list>
              <v-list-tile
                v-for="(item, index) in getDates"
                :key="index"
                @click="updateByFilters(item, 'date')"
              >
                <v-list-tile-title>{{ dateText(item) }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>
        <!--Reset Button-->
        <v-btn
          :disabled="!allowRequest || getChartStatus.loading"
          color="primary"
          flat
          small
          :ripple="false"
          @click="resetFilter"
        >
          <v-icon>autorenew</v-icon>
        </v-btn>
      </div>
    </div>
    <div>
      <v-progress-circular
        v-if="getChartStatus.loading && getChartOptions.series.length <= 0"
        :indeterminate="true"
        :size="75"
        height="3"
        color="primary"
        class="progress-circular"  />
      <v-progress-linear
        v-if="getChartStatus.loading && getChartOptions.series.length > 0"
        :indeterminate="true"
        height="3"
        color="primary"
        class="progress-card" />
      <div class="card-body">
        <apexchart
          v-if="!getChartStatus.noData"
          ref="chartFastMoving"
          type="donut"
          :height="chartHeight"
          :options="getChartOptions"
          :series="getChartOptions.series"
          class="donut-fm"
          @updated="updateModalChart()"/>
        <i-no-data heading="Oops!" v-if="getChartStatus.noData" />
      </div>
    </div>
    <div class="card-footer justify-end text-xs-right pt-0">
      <template v-if="!getChartStatus.noData">
        <v-btn
          class="ma-0"
          color="primary"
          flat
          small
          :ripple="false"
          :disabled="getChartStatus.loading"
          @click="openModal"
        >
          Full Screen <v-icon class="ml-1">fullscreen</v-icon>
        </v-btn>
        <div class="separator-line"></div>
        <!--Download Excel-->
        <v-tooltip top max-width="235px" :content-class="[`${getThemeColor === '0' ? 'dark-tooltip' : ''} +  i-tooltip`]">
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-btn
                class="ma-0"
                color="primary"
                flat
                small
                :ripple="false"
                @click="downloadExcelHandler({
                task: 'loadModule',
                downloadExcel: true,
                payload: {
                  brand_id: getSelectedFilters.brand,
                  category_id: getSelectedFilters.category,
                  seller_id: getSelectedFilters.seller,
                  date_option: getSelectedFilters.date,
                  module_id: 3
                }
              })"
              >
                <v-icon>icon-icon</v-icon>
              </v-btn>
            </div>
          </template>
          <span>Download Excel</span>
        </v-tooltip>
        <v-dialog
          v-model="popup.dialog"
          persistent
          fullscreen
          :dark="getThemeColor === '0'"
          transition="dialog-bottom-transition"
          attach
        >
          <v-card class="fast-moving-products-dialog">
            <v-toolbar card dark color="primary">
              <v-btn icon dark flat :ripple="false" @click="popup.dialog = false">
                <v-icon>close</v-icon>
              </v-btn>
              <v-toolbar-title>Fast-Moving Products</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <apexchart
                ref="chartFastMovingPopup"
                type="donut"
                height="600"
                :options="getChartOptions"
                :series="getChartOptions.series"
                class="donut-fm" />
            </v-card-text>
          </v-card>
        </v-dialog>
      </template>
    </div>
  </div>
</template>

<script>
import { AppUrl } from '@/assets/js/variables'
export default {
  name: 'parentComponent',
  data: () => ({
    window: {
      width: 0
    },
    chartHeight: 353,
    category: {
      isLoading: false,
      search: null
    },
    sellers: {
      isLoading: false,
      search: null
    },
    brand: {
      isLoading: false,
      search: null
    },
    popup: {
      dialog: false
    },
    allowRequest: true
  }),
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  mounted () {
    this.handleResize()
    if (this.getChartOptions.series.length === 0) {
      this.updateByFilters()
    }
  },
  methods: {
    handleResize () {
      this.window.width = window.innerWidth
      if (this.window.width > 1540) {
        this.chartHeight = 353
      } else if (this.window.width < 1540 && this.window.width > 1460) {
        this.chartHeight = 295
      } else if (this.window.width < 1460 && this.window.width > 1350) {
        this.chartHeight = 280
      } else if (this.window.width < 1350 && this.window.width > 1264) {
        this.chartHeight = 240
      } else {
        this.chartHeight = 300
      }
    },
    updateModalChart () {
      if (!this.getChartStatus.noData) {
        if (this.$refs.chartFastMovingPopup) {
          this.$refs.chartFastMovingPopup.refresh()
        }
      }
    },
    updateByFiltersRequest () {
      this.$store.dispatch('fastMovingProductsModule/getChart', {
        brandId: this.getSelectedFilters.brand,
        categoryId: this.getSelectedFilters.category,
        sellerId: this.getSelectedFilters.seller,
        dateOption: this.getSelectedFilters.date,
        elemRef: this.$refs.chartFastMoving
      })
    },
    updateByFilters (e, key) {
      if (!this.allowRequest) return
      this.$store.commit('fastMovingProductsModule/SET_selectedFilters', { value: e, key: key })
      this.updateByFiltersRequest()
    },
    resetFilter () {
      this.$store.commit('fastMovingProductsModule/RESET_selectedFilters')
      this.$store.dispatch('fastMovingProductsModule/getChart', {
        brandId: this.getSelectedFilters.brand,
        categoryId: this.getSelectedFilters.category,
        sellerId: this.getSelectedFilters.seller,
        dateOption: this.getSelectedFilters.date,
        elemRef: this.$refs.chartFastMoving
      }).then(() => {
        this.allowRequest = true
      }).catch(() => {
        this.allowRequest = true
      })
    },
    openModal () {
      this.popup.dialog = true
    },
    dateText (key) {
      let name = null
      switch (key) {
        case 1:
          name = 'Last 24 Hours'
          break
        case 2:
          name = 'Last Week'
          break
        case 3:
          name = 'Last Month'
          break
        case 4:
          name = 'Last 3 Months'
          break
        case 5:
          name = 'Last 6 Months'
          break
      }
      return name
    },
    downloadExcelHandler (params) {
      console.log('Params', params)
      let form = document.createElement('form')
      form.setAttribute('method', 'post')
      form.setAttribute('action', AppUrl)
      form.setAttribute('target', 'targetForm')
      for (let i in params) {
        if (params.hasOwnProperty(i)) {
          let input = document.createElement('input')
          input.type = 'hidden'
          input.name = i
          input.value = JSON.stringify(params[i])
          form.appendChild(input)
        }
      }
      document.body.appendChild(form)
      window.open('', 'targetForm')
      form.submit()
      form.remove()
    }
  },
  computed: {
    getChartStatus () {
      return this.$store.state.fastMovingProductsModule.chartStatus
    },
    getCategories () {
      return this.$store.state.fastMovingProductsModule.categories
    },
    getBrands () {
      return this.$store.state.fastMovingProductsModule.brands
    },
    getSellers () {
      return this.$store.state.fastMovingProductsModule.sellers
    },
    getDates () {
      return this.$store.state.fastMovingProductsModule.dates
    },
    getSelectedFilters () {
      return this.$store.state.fastMovingProductsModule.selectedFilters
    },
    getChartOptions () {
      return this.$store.state.fastMovingProductsModule.chartOptions
    },
    getThemeColor () {
      return this.$store.state.auth.userInfo.themeColor
    }
  },
  watch: {
    'category.search': function (val) {
      if (val === '') {
        this.$store.commit('fastMovingProductsModule/RESET_currentFilter', { key: 'category' })
        this.updateByFiltersRequest()
        return
      }
      if (this.getCategories && this.getCategories.find(el => val === el.name)) return
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.category.isLoading = true
        this.$store.dispatch('fastMovingProductsModule/getCategories', {categoryName: val, sellerId: this.getSelectedFilters.seller, brandId: this.getSelectedFilters.brand, dateOption: this.getSelectedFilters.date}).then(() => {
          this.category.isLoading = false
        })
      }, 300)
    },
    'brand.search': function (val) {
      if (val === '') {
        this.$store.commit('fastMovingProductsModule/RESET_currentFilter', { key: 'brand' })
        this.updateByFiltersRequest()
        return
      }
      if (this.getBrands && this.getBrands.find(el => val === el.name)) return
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.brand.isLoading = true
        this.$store.dispatch('fastMovingProductsModule/getBrands', {brandName: val, categoryId: this.getSelectedFilters.category, dateOption: this.getSelectedFilters.date, sellerId: this.getSelectedFilters.seller}).then(() => {
          this.brand.isLoading = false
        })
      }, 300)
    },
    'sellers.search': function (val) {
      if (val === '') {
        this.$store.commit('fastMovingProductsModule/RESET_currentFilter', { key: 'seller' })
        this.updateByFiltersRequest()
        return
      }
      if (this.getSellers && this.getSellers.find(el => val === el.name)) return
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.sellers.isLoading = true
        this.$store.dispatch('fastMovingProductsModule/getSellers', {sellerName: val, brandId: this.getSelectedFilters.brand, categoryId: this.getSelectedFilters.category, dateOption: this.getSelectedFilters.date}).then(() => {
          this.sellers.isLoading = false
        })
      }, 300)
    }
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/fast-moving/Container.vue